import { Dispatch } from "redux";
import { fetchDocuments, fetchHiddenDocuments } from "../..";
import { ApiConfig, Document } from "../../../../..";

export const processResponseCreateCustomInput = (config: ApiConfig, dispatch: Dispatch) => (result: Document, silent?: boolean): Document => {
    if (config.refreshFeed) {
        config.refreshFeed()
    }
    if (config.updateItem) {
        config.updateItem(result.docId)
      }
    if (config.getDocCB && !!silent) {
        config.getDocCB(result)
      }
      
    const ids = result.relatedDocuments.map((r) => r.relatedDocumentId)

    if(ids.length) {
        silent ? 
            dispatch<any>(fetchHiddenDocuments(config)(ids)) :
            dispatch<any>(fetchDocuments(config)(ids))
    }

    return result
}